import { MiniFaqs, MINIFAQ_SOURCES } from '@/containers/MiniFaqs';
import { useRoundStatus } from '@/hooks/shared/useRoundStatus';

export const DashboardMiniFaq = () => {
  const { status } = useRoundStatus();

  const params = {
    available_cash: status?.available_cash,
    earmarked: status?.earmarked,
    has_previously_invested: status?.has_previously_invested,
    investment_option: status?.option,
  };

  return (
    <MiniFaqs
      source={MINIFAQ_SOURCES.dashboard}
      params={params}
      disabled={!status}
    />
  );
};
